import { getApiBaseUrl } from 'src/api/config/apiBaseUrl';
import { createCsrfAwareAxiosInstance } from 'src/api/common/http/createCsrfAwareAxiosInstance';

const wfAxiosInstance = createCsrfAwareAxiosInstance(getApiBaseUrl(), '/api/wf/csrf');

export default wfAxiosInstance;
